<template>
  <v-card
    class="login-card"
    flat
  >
    <template v-if="card === 'select'">
      <div class="login-content">
        <h1 class="login-title">
          {{ $t('welcome.logged-out.title') }}
        </h1>

        <p class="login-description">
          {{ $t('welcome.logged-out.body') }}
          <!-- <a href="" target="_blank">{{ $t('welcome.logged-out.link') }}</a> -->
        </p>

        <!-- BankID -->
        <v-btn
          class="login-option login-option--primary v-btn--full-width"
          block
          depressed
          @click="doExternalLogin"
        >
          <div class="login-option__content">
            <v-icon class="login-option__icon">
              $sl-bankid
            </v-icon>
  
            <span>{{ $t('login.password.log-in') }}</span>
          </div>
        </v-btn>

        <!-- Email/password -->
        <ActionButton class="mt-4 v-btn--full-width" type="secondary" @click="showCard('email')">
          <v-icon size="15" class="mr-4">$sl-arrow-right</v-icon>
          {{ $t('login.email-password-label') }}
        </ActionButton>

        <!-- Additional links -->
        <div class="login-links">
          <button
            type="button"
            class="login-link"
            @click="showCard('employer')"
          >
            <span>{{ $t('welcome.company-title') }}</span>

            <v-icon>$sl-arrow-right</v-icon>
          </button>

          <button
            type="button"
            class="login-link"
            @click="showCard('minor')"
          >
            <span>{{ $t('welcome.underage-title') }}</span>

            <v-icon>$sl-arrow-right</v-icon>
          </button>

          <button
            type="button"
            class="login-link"
            @click="showCard('login-byn2')"
          >
            <span class="text-truncate">{{ $t('labels.login-byn2-link') }}</span>

            <v-icon>$sl-arrow-right</v-icon>
          </button>

          <button
            v-if="showDevLogins"
            type="button"
            class="login-link login-link--border"
            @click="showCard('test-users')"
          >
            <span>{{ $t('labels.test-login') }}</span>

            <v-icon>$sl-arrow-right</v-icon>
          </button>
        </div>
      </div>
    </template>

    <template v-else-if="card === 'email'">
      <div class="login-content">
        <div class="d-flex align-center justify-space-between mb-6">
          <button class="d-flex align-center" @click="showCard('select')">
            <v-icon left small>
              $sl-arrow-left
            </v-icon>
            {{ $t('company.btnBack') }}
          </button>
        </div>

        <p class="subtitle-2 mx-auto text-center">
          {{ $t('login.email-login') }}
        </p>

        <EmailLogin />
      </div>
    </template>

    <template v-else-if="card === 'employer'">
      <div class="login-content">
        <div class="d-flex align-center justify-space-between mb-6">
          <button class="d-flex align-center" @click="showCard('select')">
            <v-icon left small>
              $sl-arrow-left
            </v-icon>
            {{ $t('company.btnBack') }}
          </button>
        </div>

        <p class="subtitle-2 mx-auto text-center">
          {{ $t('welcome.company-title') }}
        </p>

        <Employer />
      </div>
    </template>

    <template v-else-if="card === 'minor'">
      <div class="login-content">
        <div class="d-flex align-center justify-space-between mb-6">
          <button class="d-flex align-center" @click="showCard('select')">
            <v-icon left small>
              $sl-arrow-left
            </v-icon>
            {{ $t('company.btnBack') }}
          </button>
        </div>

        <p class="subtitle-2 mx-auto text-center">{{ $t('welcome.underage-title') }}</p>

        <Minor />
      </div>
    </template>

    <template v-else-if="card === 'login-byn2'">
      <div class="login-content">
        <div class="d-flex align-center justify-space-between mb-6">
          <button class="d-flex align-center" @click="showCard('select')">
            <v-icon left small>
              $sl-arrow-left
            </v-icon>
            {{ $t('company.btnBack') }}
          </button>
        </div>

        <p class="subtitle-2 mx-auto text-center">{{ $t('labels.login-byn2') }}</p>

        <LoginByn2 />
      </div>
    </template>

    <template v-else-if="card === 'test-users' && showDevLogins">
      <div class="login-content">
        <div class="d-flex align-center justify-space-between mb-6">
          <button class="d-flex align-center" @click="showCard('select')">
            <v-icon left small>
              $sl-arrow-left
            </v-icon>
            {{ $t('company.btnBack') }}
          </button>
        </div>

        <p class="subtitle-2 mx-auto text-center">{{ $t('labels.test-login') }}</p>

        <TestUsers />
      </div>
    </template>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'
import API from '@/services/api'
import EmailLogin from './EmailLogin.vue';
import ActionButton from '@/components/Common/ActionButton'
import Employer from './links/Employer.vue';
import Minor from './links/Minor.vue';
import LoginByn2 from './links/LoginByn2.vue';
import TestUsers from './links/TestUsers.vue';

export default {
  name: 'LoginDeck',

  components: {
    EmailLogin,
    ActionButton,
    Employer,
    Minor,
    LoginByn2,
    TestUsers
  },

  data: () => ({
    card: 'select',
  }),

  methods: {
    ...mapActions('currentuser', ['setCurrentUser']),

    doExternalLogin() {
      console.log('LoginDeck - doExternalLogin')

      API.bankIdExternal({
        callback: Buffer.from(
          window.location.protocol +
          '//' +
          window.location.host +
          '/loginreturn'
        ).toString('base64'),
      })
        .then(res => {
          if (res.data.redirectUrl) {
            window.location = res.data.redirectUrl
          }
        })
        .catch(err => {
          console.log('Error:', err)
        })
    },

    showCard(cardname) {
      this.card = cardname
    },
  },

  computed: {
    showDevLogins() {
      return Boolean(process.env.VUE_APP_USE_FAKE_LOGINS === 'true')
    }
  }
}
</script>

<style lang="scss" scoped>
.login-card {
  width: 100%;
  max-width: 400px;
  min-height: 450px;
  padding: 24px;

  background: #fff !important;
  border-radius: 16px !important;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.075) !important;

  /* ----------------------------------------
     Heading
  ---------------------------------------- */

  .login-title {
    margin: 0;
    color: #44474f !important;
    font-size: 18px !important;
    line-height: 24px !important;
    font-weight: 600 !important;
    letter-spacing: 0.15px !important;
    text-align: center;
    text-transform: initial !important;
  }

  .login-description {
    margin: 1.5rem 0;
    color: #44474f;
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
    letter-spacing: 0.5px;
    text-align: center;
  }

  /* ----------------------------------------
     Login buttons
  ---------------------------------------- */

  .login-option {
    height: 56px !important;
    border-radius: 56px !important;
    text-transform: none !important;
    font-size: 14px !important;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: 0.1px;
    box-shadow: none !important;

    &__content {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      gap: .25rem;
    }

    &--primary {
      text-align: center !important;
      margin-bottom: 20px;
      background-color: $color-primary !important;
      color: #fff !important;
      
      .v-icon {
        flex-shrink: 0;
        fill: #fff !important;
      }

      &:hover {
        background-color: #00747b !important;
      }
    }

    &__icon {
      color: #fff !important;
      width: 36px;
      height: 36px;
    }

    &__arrow {
      color: #44474f !important;
      width: 14px;
      height: 14px;
    }
  }

  /* ----------------------------------------
     Bottom links
  ---------------------------------------- */

  .login-links {
    margin-top: 38px;
  }

  .login-link {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 0;
    border: 0;
    background: transparent;
    color: #44474f;
    font-family: inherit;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 0.5px;
    cursor: pointer;

    &:hover {
      color: $color-primary !important;
    }

    .v-icon {
      flex-shrink: 0;
      color: #44474f !important;
      width: 14px !important;
    }

    &--border {
      margin-top: 14px;
      padding-top: 12px;
      border-top: 1px solid #bfc8ca;
    }
  }
}
</style>